import React, { useState, useEffect } from 'react';
import sliderLandingData from '../data/sliderLandingData';

export default function LandingSlider() {
    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? sliderLandingData.length - 1 : prevIndex - 1
        );
    };

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === sliderLandingData.length - 1 ? 0 : prevIndex + 1
        );
    };

    useEffect(() => {
        const autoplay = setInterval(() => {
            nextSlide();
        }, 3500);
        return () => clearInterval(autoplay);
    }, [currentIndex]);
    return (
        <div className="relative w-full overflow-hidden">
            <div
                className="flex transition-transform duration-700"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
                {sliderLandingData.map((el) => (
                    <div key={el.id} className="w-full flex-shrink-0">
                        <img
                            className="hv-25 w-full h-[70vh] object-cover"
                            src={el.image}
                            alt={`Banner ${el.id + 1}`}
                        />
                    </div>
                ))}
            </div>

            <button
                onClick={prevSlide}
                className="wh-30 absolute top-1/2 left-4 transform -translate-y-1/2 bg-[#20bcb4] w-[35px] h-[35px] flex items-center justify-center text-white rounded-full p-2 hover:bg-[#0387c1]"
            >
                ❮
            </button>
            <button
                onClick={nextSlide}
                className="wh-30 absolute top-1/2 right-4 transform -translate-y-1/2 bg-[#20bcb4] w-[35px] h-[35px] flex items-center justify-center text-white rounded-full p-2 hover:bg-[#0387c1]"
            >
                ❯
            </button>

            <div className="d-none absolute bottom-4 left-1/2 transform -translate-x-1/2 flex items-center space-x-2">
                {sliderLandingData.map((_, index) => (
                    <div
                        key={index}
                        onClick={() => setCurrentIndex(index)}
                        className={`w-3 h-3 rounded-full cursor-pointer transition-all duration-500 ${index === currentIndex ? 'bg-white h-[40px]' : 'bg-white'
                            }`}
                    ></div>
                ))}
            </div>

        </div>
    );
}